import {
  FETCH_BRANCH_FAIL,
  FETCH_BRANCH_REQUEST,
  FETCH_BRANCH_SUCCESS,
} from "../../ActionType/BranchType/BranchType";

export const getBranchReducer = (
  state = { loading: true, branches: [], error: "" },
  action
) => {
  switch (action.type) {
    case FETCH_BRANCH_REQUEST:
      return {
        loading: true,
        branches:action.payload
      };
    case FETCH_BRANCH_SUCCESS:
      return {
        loading: false,
        branches:action.payload,
        error:"",
      };
    case FETCH_BRANCH_FAIL:
      return {
        loading: false,
        branches:action.payload,
        error:"",
      };
    default:
      return state;
  }
};

